import { useReducer } from 'react';

const getActionTypes = prefix => {
  prefix = prefix ? `${prefix}:` : '';

  return {
    TOGGLE: `Action: ${prefix}:TOGGLE`,
    TOGGLE_ON: `Action: ${prefix}:TOGGLE_ON`,
    TOGGLE_OFF: `Action: ${prefix}:TOGGLE_OFF`
  };
};

const getReducer = actionTypes => (oldState, action) => {
  switch (action.type) {
    case actionTypes.TOGGLE:
      return { isOn: !oldState.isOn };

    case actionTypes.TOGGLE_ON:
      return { isOn: true };

    case actionTypes.TOGGLE_OFF:
      return { isOn: false };

    default:
      throw new Error(`Unrecognized action: ${action.type}`);
  }
};

const getUseOn = actionTypes => dispatch => () => dispatch({ type: actionTypes.TOGGLE_ON });
const getUseOff = actionTypes => dispatch => () => dispatch({ type: actionTypes.TOGGLE_OFF });
const getUseToggle = actionTypes => dispatch => () => dispatch({ type: actionTypes.TOGGLE });

const useToggleable = ({ actionPrefix, isOn } = {}) => {
  const actionTypes = getActionTypes(actionPrefix);

  const useOn = getUseOn(actionTypes);
  const useOff = getUseOff(actionTypes);
  const useToggle = getUseToggle(actionTypes);

  const [state, dispatch] = useReducer(getReducer(actionTypes), { isOn: typeof isOn === 'boolean' ? isOn : false });

  const on = useOn(dispatch);
  const off = useOff(dispatch);
  const toggle = useToggle(dispatch);

  return { ...state, on, off, toggle };
};

export default useToggleable;
